export default "__VITE_ASSET__CHvRHHW9__"